module.exports = __webpack_public_path__ + "static/media/nofound.1c805dd9.png";